export const SUBMIT_RENEWAL_REQUEST = "SUBMIT_RENEWAL_REQUEST";
export const SUBMIT_RENEWAL_SUCCESS = "SUBMIT_RENEWAL_SUCCESS";
export const SUBMIT_RENEWAL_FAILURE = "SUBMIT_RENEWAL_FAILURE";

export const submitRenewalRequest = (formData) => {
  return (dispatch) => {
    dispatch({
        type: SUBMIT_RENEWAL_REQUEST,
        payload: formData,
    });
  };
};

export const submitRenewalSuccess = (message) => ({
  type: SUBMIT_RENEWAL_SUCCESS,
  payload: message,
});

export const submitRenewalFailure = (error) => ({
  type: SUBMIT_RENEWAL_FAILURE,
  payload: error,
});
